import { useEffect, useState } from 'react';
import { Card, Result, Spin, Typography } from 'antd';
import { ToolOutlined } from '@ant-design/icons';
import { trpc } from '../lib/api';

const { Paragraph } = Typography;

function CountdownTimer({ endTime }: { endTime: string }) {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const end = new Date(endTime).getTime();
      const distance = end - now;

      if (distance < 0) {
        setTimeLeft('まもなく終了');
        clearInterval(interval);
      } else {
        const hours = Math.floor(distance / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        setTimeLeft(`残り ${hours}時間 ${minutes}分`);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [endTime]);

  return (
    <div style={{ marginTop: 16, fontSize: 18, fontWeight: 'bold', color: '#1890ff' }}>
      {timeLeft}
    </div>
  );
}

export function MaintenancePage() {
  const statusQuery = trpc.maintenanceMode.checkStatus.useQuery(undefined, {
    refetchInterval: 30000 // 30秒ごとにステータスをチェック
  });

  useEffect(() => {
    if (statusQuery.data && !statusQuery.data.isInMaintenance) {
      window.location.href = '/';
    }
  }, [statusQuery.data]);

  if (statusQuery.isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f0f2f5' }}>
        <Spin size="large" tip="読み込み中..." />
      </div>
    );
  }

  const config = statusQuery.data?.config;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f0f2f5', padding: 24 }}>
      <Card style={{ maxWidth: 600, width: '100%' }}>
        <Result
          icon={<ToolOutlined style={{ color: '#faad14' }} />}
          title="メンテナンス中"
          subTitle="現在システムメンテナンスを実施しております"
        >
          <div style={{ textAlign: 'center' }}>
            <Paragraph style={{ fontSize: 16 }}>
              {config?.message.ja || 'システムメンテナンス中です。しばらくお待ちください。'}
            </Paragraph>

            {config?.estimatedEndTime && (
              <div style={{ marginTop: 24 }}>
                <Paragraph type="secondary">
                  終了予定時刻: {new Date(config.estimatedEndTime).toLocaleString('ja-JP')}
                </Paragraph>
                <CountdownTimer endTime={config.estimatedEndTime} />
              </div>
            )}

            <div style={{ marginTop: 32 }}>
              <Paragraph type="secondary">
                メンテナンス終了後、自動的にページが更新されます。
              </Paragraph>
              <Spin size="small" />
            </div>
          </div>
        </Result>
      </Card>
    </div>
  );
}
